<div class="u-borderBottom-grey100" mat-dialog-title>
  <span i18n="@@confirmPromptDialog.title">{data.title, select,
    other {{{ data.title }}}
  }</span>
</div>
<mat-dialog-content class="u-borderBottom-grey100">
  @if (data.image) {
    <div fxLayout="row" fxLayoutAlign="center">
      <img
        [ngStyle]="{ height: '100px', maxWidth: '250px' }"
        [src]="data.image"
        alt=""
      />
    </div>
  }
  <div class="u-paddingTop-16 u-text-maxWidth">
    <ng-container
      i18n="@@confirmPromptDialog.content"
      *nzStringTemplateOutlet="data.content"
      >{data.content, select, other {{{ data.content }}}
    }</ng-container>
  </div>
</mat-dialog-content>
<mat-dialog-actions
  [fxLayoutAlign]="
    data.secondary?.label && data.cancel ? 'space-between center' : 'end center'
  "
  class="u-padding-0-8"
  fxLayout="row"
  fxLayoutGap="8px"
>
  @if (data.cancel) {
    <button mat-button mat-dialog-close>
      <span
        i18n="@@confirmPromptDialog.cancel.buttonLabel"
        >{data.cancel, select, other {{{ data.cancel }}}
      }</span>
    </button>
  }
  <div fxLayout="row" fxLayoutGap="8px">
    @if (data.confirm) {
      <button
        [color]="data.color || 'primary'"
        (click)="selectPrimary()"
        fxFlexOrder="2"
        mat-raised-button
      >
        <span
          i18n="@@confirmPromptDialog.confirm.buttonLabel"
          >{data.confirm, select, other {{{ data.confirm }}}
        }</span>
      </button>
    }
    @if (data.secondary?.label) {
      <button
        [color]="data.secondary.color || 'warn'"
        (click)="selectSecondary()"
        fxFlexOrder="1"
        mat-button
      >
        <span
          i18n="@@confirmPromptDialog.secondary.buttonLabel"
          >{data.secondary.label, select, other {{{ data.secondary.label }}}
        }</span>
      </button>
    }
  </div>
</mat-dialog-actions>
